import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=50bd2c7e&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=50bd2c7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bd2c7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50bd2c7e')) {
      api.createRecord('50bd2c7e', component.options)
    } else {
      api.reload('50bd2c7e', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=50bd2c7e&scoped=true&", function () {
      api.rerender('50bd2c7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2WmM40PbFsFJc/JS/teamMember.vue"
export default component.exports